import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalWindowClass } from '../../classes/modal-window.class';

@Component({
  selector: 'real-estate-website-become-seller',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './become-seller.component.html',
  styleUrl: './become-seller.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BecomeSellerComponent extends ModalWindowClass<BecomeSellerComponent> {}
